import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { PaymentMethodIconComponent } from './payment-method-icon.component';

@NgModule({
  imports: [UiModule, CommonModule],
  declarations: [PaymentMethodIconComponent],
  exports: [PaymentMethodIconComponent],
})
export class PaymentMethodIconModule {}
